var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h1"}),_c('div',[_c('img',{staticStyle:{"width":"100%","height":"3.54rem"},attrs:{"src":require("../assets/imgs/tck/免费领取.gif"),"alt":""},on:{"click":function($event){return _vm.to_api()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }